export default __webpack_public_path__ + "static/img7-db11b920c914d094eefa44347b454fbc.webp";